<template>
  <div class="layer packageServiceDetail">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"><span class="blind">close</span></button>
      <h2 class="layerTitle toCapitalize">패키지 서비스</h2>
      <div class="serviceDetail">
        <!-- 서비스 정보 및 링크 -->
        <div class="info">
          <!-- 사용여부 -->
          <div class="mb15">
            <span class="checkbox">
              <input type="checkbox" :id="`${content.psId}_active`" class="checkbox" v-model="content.isActive">
              <label :for="`${content.psId}_active`">{{locale.activate}}</label>
            </span>
          </div>
          <!-- //사용여부 -->
          <!-- 서비스이름 -->
          <div class="innerItem isRequired">
            <div class="innerTitle setLabel">{{locale.name}}</div>
            <input type="text" class="input" v-model="content.title">
          </div>
          <!-- //서비스이름 -->
          <!-- 제목 (display) -->
          <div class="innerItem isRequired">
            <div class="innerTitle setLabel">{{locale.title}}</div>
            <div class="siteTitle translation">
              <textarea class="input" row="5" v-model="content.linkContent[lang.default]" @focusout="setDefaultVal('linkContent')"></textarea>
              <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click.stop="onLangValueOpen('linkContent')">
                <span class="blind">{{locale.language_specific_set}}</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
              </button>
            </div>
          </div>
          <!-- //제목 (display) -->
          <!-- 서비스 컴포넌트 -->
          <div class="innerItem">
            <div class="innerTitle setLabel">
              컴포넌트
              <button type="button" class="btnSetting" @click.stop="setComponentList"><img src="@/assets/img/ico_setting.svg" alt=""></button>
            </div>
            <div class="serviceComponents">
              <div v-for="comp in content.components"
                :key="comp"
                class="componentItem" @click.stop="delComponentItem(comp)">
                {{ comp }}
              </div>
            </div>
          </div>
          <!-- //서비스 컴포넌트 -->
        </div>
        <!-- //서비스 정보 및 링크 -->
        <!-- 서비스링크 -->
        <div class="serviceLink">
          <div class="innerItem isRequired">
            <div class="innerTitle setLabel">{{locale.link}}</div>
            <SetLink
              :locale="locale"
              :link="detailLink"
              :fix="['page', 'reservation', 'product', 'shortcut', 'outlink', 'func']"
              :checkedInfo="checkedInfo" />
          </div>
        </div>
        <!-- //서비스링크 -->
      </div>
      <div class="btns">
        <button v-if="detail !== 'new'" type="button" class="btn btnRed btnDel" @click="del">{{locale.delete}}</button>
        <button type="button" class="btn btnFull btnPrimary toCapitalize" @click="apply">{{locale.save}}</button>
      </div>
    </div>
    <!-- 언어별 세팅 -->
    <LangValue v-show="langValueLayer"
      :locale="locale"
      :textarea="true"
      :langValue="langValue"
      :title="locale.language_specific_set"
      @close="onLangValueClose" />
    <!-- //언어별 세팅 -->
    <!-- 컴포넌트 리스트 -->
    <ComponentList
      v-if="componentLayer"
      :locale="locale"
      :componentList="content.components"
      @apply="applyComponentList"
      @close="closeComponentList" />
    <!-- 컴포넌트 리스트 -->
  </div>
</template>

<script>
import moment from 'moment/moment'
import SetLink from '@/components/Util/SetLink'
import LangValue from '@/components/Util/LangValue.vue'
import UNIQUE from '@/common/unique'
import UTIL from '@/common/util'
import LANG from '@/common/lang'
import ComponentList from '@/components/Package/ComponentList'

export default {
  name: 'PackageServiceDetail',
  props: [
    'locale',
    'detail',
    'checkedInfo'
  ],
  components: {
    SetLink,
    LangValue,
    ComponentList
  },
  computed: {
    lang () {
      const settingData = this.$store.getters['setting/getData']
      return settingData && settingData.lang
    },
    langList () {
      const langSetting = this.$store.getters['setting/getData']
      const list = langSetting && langSetting.lang && langSetting.lang.info
      const usableLang = langSetting && langSetting.lang && langSetting.lang.usable
      return list && list.filter(x => usableLang.includes(x.c))
    },
    detailLink: {
      get () {
        return this.content.link
      },
      set (data) {
        this.content.link
      }
    }
  },
  mounted () {
    this.init()
  },
  data () {
    let content = {
      psId: '',
      index: null,
      title: '',
      components: [],
      isActive: true,
      ...this.detail && this.detail !== 'new' ? this.detail : null,
      linkContent: {...LANG.valueObj(), ...this.detail.linkContent},
      link: {
        pageId: (this.detail && this.detail.linkType === 'page' && this.detail.linkUUID) || '',
        productId: (this.detail && this.detail.linkType === 'product' && this.detail.linkUUID) || '',
        reservationId: (this.detail && this.detail.linkType === 'reservation' && this.detail.linkUUID) || '',
        ticketFunc: (this.detail && this.detail.linkType === 'ticket' && this.detail.linkUUID) || '',
        funcId: this.detail && this.detail.linkType === 'ticket' ? 'ticket' : '',
        target: false,
        type: (this.detail && this.detail.linkType  && this.detail.linkType === 'ticket') ? 'func' : (this.detail && this.detail.linkType) || 'reservation',
        url: (this.detail && this.detail.linkURL) || this.$store.getters['setting/getLangValues']()
      }
    }
    return {
      content,
      langValueLayer: false,
      langValue: {},
      componentLayer: false
    }
  },
  methods: {
    init () {
    },
    setDefaultVal (target) {
      const defaultLang = this.lang.default
      const fillLangs = UTIL.fillLangs(this.content[target], this.content[target][defaultLang])
      this.content[target] = fillLangs
    },
    onLangValueOpen (target) {
      this.langValueLayer = true
      this.currentContent = target
      this.langValue = this.content[target]
      // this.setDefaultVal(target)
    },
    onLangValueClose () {
      const target = this.currentContent
      this.langValueLayer = false
      this.content[target] = this.langValue
      this.langValue = {}
    },
    setComponentList () {
      this.componentLayer = true
    },
    applyComponentList (components) {
      this.content.components = (components || []).map(x => x.code)
      this.closeComponentList()
    },
    closeComponentList () {
      this.componentLayer = false
    },
    delComponentItem (code) {
      if (window.confirm(this.locale.confirm_delete)) {
        this.content.components = this.content.components.filter(x => x !== code)
        alert(this.locale.complete_delete)
      }
    },
    close () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.$emit('close')
      }
    },
    del () {
      if (window.confirm(this.locale.confirm_delete)) {
        this.$emit('delete', this.detail.psId)
      }
    },
    apply () {
      let data = this.content
      if (data.link.type === 'func' && data.link.funcId === 'ticket' && !data.link.ticketFunc) {
        data.link.ticketFunc = UNIQUE.mid()
      }
      if (window.confirm(this.locale.confirm_save)) {
        if (this.detail === 'new') {
          data.psId = UNIQUE.mid()
          data.createat = moment().toISOString()
          this.$emit('add', data)
        } else {
          this.$emit('apply', data)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.isRequired {
  .innerTitle:before {
    content: "*";
    color: $color-red;
  }
  .setLabel.innerTitle {
    padding-left: 1.3em;
    &:before {
      text-indent: 0.7em;
    }
  }
}
</style>
